// On adding a privilege here update privilegesMapping variable"
const privileges = {
  UBEYA_ADMIN: -1,
  ACCOUNT_ADMIN: 1,
  BRANCH_ADMIN: 2,
  MANAGER_ADMIN: 3,
  EDIT_PERMISSIONS: 4,
  TIMESHEET: 5,
  PAYROLL: 6,
  DIRECTORY: 7,
  COMMUNICATION: 8,
  CRM: 9,
  SCHEDULING: 10,
  FEED: 11,
  EDIT_HR: 12,
  SEQUENCE: 13,
  BILLING: 14,
  CLIENT_BILLING: 15,
  COMPLIANCE: 16,
  REPORTS: 17,
  DELETE_EMPLOYEE: 18,
  UNLOCK_PAYROLL: 19,
  EXPORT_PROCESS_PAYROLL: 20,
  SUPPLIERS: 21,
  APPROVE_TIMESHEET: 22,
  EDIT_SCHEDULING: 23,
  ADD_EMPLOYEE: 24,
  INVOICE: 25,
  AMEND_PAY_RATE: 26,
  EDIT_CONTRACT_TYPE: 27,
  MANAGE_EMPLOYEE_HOLIDAY_ACCRUAL: 28,
  EDIT_AND_CREATE_SEQUENCE: 29,
  APPROVE_PTO_REQUESTS: 30,
  SENSITIVE_DATA_ACCESS: 31,
  SHIFT_TASKS: 32,
  EDIT_AND_CREATE_SHIFT_TASKS: 33,
  KIOSK_TABLET: 34,
  MANAGE_MAIN_PROJECTS: 35,
  DELETE_EVENTS: 36,
  EXPORT_EMPLOYEES_LISTS: 37,
  ASSIGN_EVENTS_TO_MAIN_PROJECT: 38,
  CREATE_ORDER: 39,
  EDIT_PAYROLL_FIELDS_ON_TIMESHEETS: 41,
  VIEW_CHAT: 40,
  CONTRACT_INFORMATION_ACCESS: 42,
  ATS: 43,
  ATS_CREATE_OPENINGS: 44
};

export const PRIVILEGES_CATEGORIES = {
  EMPLOYEES: 'employees',
  CONTRACTS: 'contracts',
  SCHEDULING: 'scheduling',
  TIMESHEET: 'timesheet',
  COMMUNICATION: 'communication',
  REPORTS: 'reports',
  CRM: 'crm',
  FINANCE: 'finance',
  WORKFLOWS: 'workflows',
  SHIFT_TASKS: 'shiftTasks',
  COMPLIANCE: 'compliance',
  ADDITIONAL: 'additional',
  SUPPLIERS: 'suppliers',
  INVOICE: 'invoice'
};

export const privilegesMappingOrder = {
  [PRIVILEGES_CATEGORIES.EMPLOYEES]: 1,
  [PRIVILEGES_CATEGORIES.CONTRACTS]: 2,
  [PRIVILEGES_CATEGORIES.SCHEDULING]: 3,
  [PRIVILEGES_CATEGORIES.TIMESHEET]: 4,
  [PRIVILEGES_CATEGORIES.COMMUNICATION]: 5,
  [PRIVILEGES_CATEGORIES.REPORTS]: 6,
  [PRIVILEGES_CATEGORIES.CRM]: 7,
  [PRIVILEGES_CATEGORIES.SUPPLIERS]: 8,
  [PRIVILEGES_CATEGORIES.FINANCE]: 9,
  [PRIVILEGES_CATEGORIES.WORKFLOWS]: 10,
  [PRIVILEGES_CATEGORIES.SHIFT_TASKS]: 11,
  [PRIVILEGES_CATEGORIES.COMPLIANCE]: 12,
  [PRIVILEGES_CATEGORIES.ADDITIONAL]: 13,
  [PRIVILEGES_CATEGORIES.INVOICE]: 14
};

export const privilegesMapping = {
  [privileges.EDIT_PERMISSIONS]: PRIVILEGES_CATEGORIES.ADDITIONAL,
  [privileges.TIMESHEET]: PRIVILEGES_CATEGORIES.TIMESHEET,
  [privileges.APPROVE_TIMESHEET]: PRIVILEGES_CATEGORIES.TIMESHEET,
  [privileges.PAYROLL]: PRIVILEGES_CATEGORIES.FINANCE,
  [privileges.CRM]: PRIVILEGES_CATEGORIES.CRM,
  [privileges.SUPPLIERS]: PRIVILEGES_CATEGORIES.SUPPLIERS,
  [privileges.SCHEDULING]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.FEED]: PRIVILEGES_CATEGORIES.COMMUNICATION,
  [privileges.VIEW_CHAT]: PRIVILEGES_CATEGORIES.COMMUNICATION,
  [privileges.EDIT_HR]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.SEQUENCE]: PRIVILEGES_CATEGORIES.WORKFLOWS,
  [privileges.EDIT_AND_CREATE_SEQUENCE]: PRIVILEGES_CATEGORIES.WORKFLOWS,
  [privileges.SHIFT_TASKS]: PRIVILEGES_CATEGORIES.SHIFT_TASKS,
  [privileges.EDIT_AND_CREATE_SHIFT_TASKS]: PRIVILEGES_CATEGORIES.SHIFT_TASKS,
  [privileges.BILLING]: PRIVILEGES_CATEGORIES.ADDITIONAL,
  [privileges.CLIENT_BILLING]: PRIVILEGES_CATEGORIES.CRM,
  [privileges.COMPLIANCE]: PRIVILEGES_CATEGORIES.COMPLIANCE,
  [privileges.REPORTS]: PRIVILEGES_CATEGORIES.REPORTS,
  [privileges.DELETE_EMPLOYEE]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.ATS]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.ATS_CREATE_OPENINGS]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.UNLOCK_PAYROLL]: PRIVILEGES_CATEGORIES.FINANCE,
  [privileges.EXPORT_PROCESS_PAYROLL]: PRIVILEGES_CATEGORIES.FINANCE,
  [privileges.EDIT_SCHEDULING]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.MANAGE_MAIN_PROJECTS]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.ASSIGN_EVENTS_TO_MAIN_PROJECT]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.DELETE_EVENTS]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.ADD_EMPLOYEE]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.INVOICE]: PRIVILEGES_CATEGORIES.FINANCE,
  [privileges.AMEND_PAY_RATE]: PRIVILEGES_CATEGORIES.FINANCE,
  [privileges.EDIT_CONTRACT_TYPE]: PRIVILEGES_CATEGORIES.CONTRACTS,
  [privileges.MANAGE_EMPLOYEE_HOLIDAY_ACCRUAL]: PRIVILEGES_CATEGORIES.CONTRACTS,
  [privileges.APPROVE_PTO_REQUESTS]: PRIVILEGES_CATEGORIES.CONTRACTS,
  [privileges.SENSITIVE_DATA_ACCESS]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.KIOSK_TABLET]: PRIVILEGES_CATEGORIES.TIMESHEET,
  [privileges.EXPORT_EMPLOYEES_LISTS]: PRIVILEGES_CATEGORIES.EMPLOYEES,
  [privileges.CREATE_ORDER]: PRIVILEGES_CATEGORIES.SCHEDULING,
  [privileges.EDIT_PAYROLL_FIELDS_ON_TIMESHEETS]: PRIVILEGES_CATEGORIES.TIMESHEET,
  [privileges.CONTRACT_INFORMATION_ACCESS]: PRIVILEGES_CATEGORIES.CONTRACTS
};

export default privileges;

// make a map from privileges
export const mapPrivileges = (privilegesData = []) =>
  privilegesData.reduce((prev, id) => ({ ...prev, [id]: true }), {});

export const allPrivilegesExcept = (...exceptPrivileges) =>
  Object.values(privileges).filter((value) => !exceptPrivileges.includes(value));

export const ubeyaPrivileges = allPrivilegesExcept(privileges.BRANCH_ADMIN, privileges.MANAGER_ADMIN).reduce(
  (prev, value) => ({ ...prev, [value]: true }),
  { [privileges.UBEYA_ADMIN]: true }
);
